import '@angular/compiler';
import { PortalDizestEditorVideoComponent } from './portal.dizest.editor.video/portal.dizest.editor.video.component';
import { PortalInfraIpTableComponent } from './portal.infra.ip.table/portal.infra.ip.table.component';
import { PageAdminTemplateItemComponent } from './page.admin.template.item/page.admin.template.item.component';
import { PortalDizestEditorImageComponent } from './portal.dizest.editor.image/portal.dizest.editor.image.component';
import { PageDeployComponent } from './page.deploy/page.deploy.component';
import { PageAdminImagesComponent } from './page.admin.images/page.admin.images.component';
import { PageAccessComponent } from './page.access/page.access.component';
import { PageAdminHostsComponent } from './page.admin.hosts/page.admin.hosts.component';
import { PortalDizestEditorSettingComponent } from './portal.dizest.editor.setting/portal.dizest.editor.setting.component';
import { PageAdminUsersComponent } from './page.admin.users/page.admin.users.component';
import { PortalChartjsLineComponent } from './portal.chartjs.line/portal.chartjs.line.component';
import { PortalDizestEditorWorkflowSidebarCodeComponent } from './portal.dizest.editor.workflow.sidebar.code/portal.dizest.editor.workflow.sidebar.code.component';
import { PortalDizestEditorWorkflowSidebarPipComponent } from './portal.dizest.editor.workflow.sidebar.pip/portal.dizest.editor.workflow.sidebar.pip.component';
import { PortalInfraProjectMemberNewComponent } from './portal.infra.project.member.new/portal.infra.project.member.new.component';
import { ComponentNavSidebarComponent } from './component.nav.sidebar/component.nav.sidebar.component';
import { PortalInfraHostTableComponent } from './portal.infra.host.table/portal.infra.host.table.component';
import { PageGuideComponent } from './page.guide/page.guide.component';
import { PortalDizestEditorWorkflowSidebarApiComponent } from './portal.dizest.editor.workflow.sidebar.api/portal.dizest.editor.workflow.sidebar.api.component';
import { PortalSeasonModalComponent } from './portal.season.modal/portal.season.modal.component';
import { PortalChartjsPieComponent } from './portal.chartjs.pie/portal.chartjs.pie.component';
import { PortalSeasonLoadingSeasonComponent } from './portal.season.loading.season/portal.season.loading.season.component';
import { PortalDizestEditorWorkflowSidebarAiComponent } from './portal.dizest.editor.workflow.sidebar.ai/portal.dizest.editor.workflow.sidebar.ai.component';
import { PortalInfraProjectDeployComponent } from './portal.infra.project.deploy/portal.infra.project.deploy.component';
import { PortalSeasonTreeComponent } from './portal.season.tree/portal.season.tree.component';
import { PageAdminTemplateComponent } from './page.admin.template/page.admin.template.component';
import { PageMypageComponent } from './page.mypage/page.mypage.component';
import { PageProjectGroupComponent } from './page.project.group/page.project.group.component';
import { PageProjectItemComponent } from './page.project.item/page.project.item.component';
import { PortalDizestEditorDefaultComponent } from './portal.dizest.editor.default/portal.dizest.editor.default.component';
import { LayoutEmptyComponent } from './layout.empty/layout.empty.component';
import { PortalInfraProjectDetailComponent } from './portal.infra.project.detail/portal.infra.project.detail.component';
import { PageAdminDnsComponent } from './page.admin.dns/page.admin.dns.component';
import { PortalInfraProjectIpComponent } from './portal.infra.project.ip/portal.infra.project.ip.component';
import { PortalInfraProjectDeployEditComponent } from './portal.infra.project.deploy.edit/portal.infra.project.deploy.edit.component';
import { PortalInfraDropdownComponent } from './portal.infra.dropdown/portal.infra.dropdown.component';
import { PortalInfraProjectHostComponent } from './portal.infra.project.host/portal.infra.project.host.component';
import { PageAdminImagesItemComponent } from './page.admin.images.item/page.admin.images.item.component';
import { PageIpComponent } from './page.ip/page.ip.component';
import { PortalInfraProjectMonitorComponent } from './portal.infra.project.monitor/portal.infra.project.monitor.component';
import { PageHostsComponent } from './page.hosts/page.hosts.component';
import { PortalSeasonLoadingDefaultComponent } from './portal.season.loading.default/portal.season.loading.default.component';
import { PortalDizestDriveComponent } from './portal.dizest.drive/portal.dizest.drive.component';
import { PortalDizestEditorTerminalComponent } from './portal.dizest.editor.terminal/portal.dizest.editor.terminal.component';
import { PageAdminDeployComponent } from './page.admin.deploy/page.admin.deploy.component';
import { PortalDizestEditorWorkflowSidebarAppsComponent } from './portal.dizest.editor.workflow.sidebar.apps/portal.dizest.editor.workflow.sidebar.apps.component';
import { PortalSeasonFormDropdownComponent } from './portal.season.form.dropdown/portal.season.form.dropdown.component';
import { PortalSeasonPaginationComponent } from './portal.season.pagination/portal.season.pagination.component';
import { PortalInfraProjectDeployNewComponent } from './portal.infra.project.deploy.new/portal.infra.project.deploy.new.component';
import { PageAdminProjectItemComponent } from './page.admin.project.item/page.admin.project.item.component';
import { PortalDizestEditorHealthComponent } from './portal.dizest.editor.health/portal.dizest.editor.health.component';
import { PortalDizestEditorWorkflowNodeComponent } from './portal.dizest.editor.workflow.node/portal.dizest.editor.workflow.node.component';
import { PortalInfraProjectMemberComponent } from './portal.infra.project.member/portal.infra.project.member.component';
import { PageAdminIpComponent } from './page.admin.ip/page.admin.ip.component';
import { PortalDizestEditorWorkflowComponent } from './portal.dizest.editor.workflow/portal.dizest.editor.workflow.component';
import { PortalDizestEditorWorkflowSidebarInfoComponent } from './portal.dizest.editor.workflow.sidebar.info/portal.dizest.editor.workflow.sidebar.info.component';
import { PageAdminGeneralComponent } from './page.admin.general/page.admin.general.component';
import { PortalInfraProjectInfoComponent } from './portal.infra.project.info/portal.infra.project.info.component';
import { PageMainComponent } from './page.main/page.main.component';
import { PageAdminProjectComponent } from './page.admin.project/page.admin.project.component';
import { LayoutSidebarComponent } from './layout.sidebar/layout.sidebar.component';
import { PageProjectComponent } from './page.project/page.project.component';

const INDEX_PAGE = "guide";

import { URLPattern } from "urlpattern-polyfill";
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

let app_routes: Routes = [
    {
        component: LayoutSidebarComponent,
        "children": [
            {
                "path": "admin/template/:id/:tab?",
                component: PageAdminTemplateItemComponent,
                "app_id": "page.admin.template.item"
            },
            {
                "path": "deploy",
                component: PageDeployComponent,
                "app_id": "page.deploy"
            },
            {
                "path": "admin/images",
                component: PageAdminImagesComponent,
                "app_id": "page.admin.images"
            },
            {
                "path": "admin/hosts",
                component: PageAdminHostsComponent,
                "app_id": "page.admin.hosts"
            },
            {
                "path": "admin/users",
                component: PageAdminUsersComponent,
                "app_id": "page.admin.users"
            },
            {
                "path": "guide/:step?",
                component: PageGuideComponent,
                "app_id": "page.guide"
            },
            {
                "path": "admin/template",
                component: PageAdminTemplateComponent,
                "app_id": "page.admin.template"
            },
            {
                "path": "mypage",
                component: PageMypageComponent,
                "app_id": "page.mypage"
            },
            {
                "path": "project-group/:id/:tab?",
                component: PageProjectGroupComponent,
                "app_id": "page.project.group"
            },
            {
                "path": "project/:id/:tab?",
                component: PageProjectItemComponent,
                "app_id": "page.project.item"
            },
            {
                "path": "admin/dns",
                component: PageAdminDnsComponent,
                "app_id": "page.admin.dns"
            },
            {
                "path": "admin/images/:id",
                component: PageAdminImagesItemComponent,
                "app_id": "page.admin.images.item"
            },
            {
                "path": "ip",
                component: PageIpComponent,
                "app_id": "page.ip"
            },
            {
                "path": "hosts",
                component: PageHostsComponent,
                "app_id": "page.hosts"
            },
            {
                "path": "admin/deploy",
                component: PageAdminDeployComponent,
                "app_id": "page.admin.deploy"
            },
            {
                "path": "admin/project/:id/:tab?",
                component: PageAdminProjectItemComponent,
                "app_id": "page.admin.project.item"
            },
            {
                "path": "admin/ip",
                component: PageAdminIpComponent,
                "app_id": "page.admin.ip"
            },
            {
                "path": "admin/general",
                component: PageAdminGeneralComponent,
                "app_id": "page.admin.general"
            },
            {
                "path": "main",
                component: PageMainComponent,
                "app_id": "page.main"
            },
            {
                "path": "admin/project",
                component: PageAdminProjectComponent,
                "app_id": "page.admin.project"
            },
            {
                "path": "project",
                component: PageProjectComponent,
                "app_id": "page.project"
            }
        ]
    },
    {
        component: LayoutEmptyComponent,
        "children": [
            {
                "path": "access",
                component: PageAccessComponent,
                "app_id": "page.access"
            }
        ]
    }
];

export class RouteInfo {
    public path: any = "";
    public segment: any = {};

    constructor() { }
}

window.WizRoute = new RouteInfo();

let patternMatcher = (pattern: any, url: any) => {
    let urlpath = url.map((x: any) => x.path).join("/");
    let testurl = 'http://test/';
    pattern = '/' + pattern;
    urlpath = testurl + urlpath;
    pattern = new URLPattern({ pathname: pattern });
    pattern = pattern.exec(urlpath)
    if (pattern && pattern.pathname) {
        let posParams = {};
        for (let key in pattern.pathname.groups) {
            if (pattern.pathname.groups[key]) {
                posParams[key] = pattern.pathname.groups[key];
            }
        }
        window.WizRoute.path = url.map((x: any) => x.path).join("/");
        window.WizRoute.segment = posParams;

        return { consumed: url, posParams: posParams };
    }
    return null
}

let routes: Routes = [{
    matcher: (url: any) => {
        for (let i = 0; i < app_routes.length; i++) {
            let layout = app_routes[i];
            let layout_childs = layout.children;
            for (let j = 0; j < layout_childs.length; j++) {
                let child = layout_childs[j];
                let matcher = patternMatcher(child.path, url);
                if (matcher)
                    return null;
            }
        }
        return { consumed: url, posParams: {} };
    },
    redirectTo: INDEX_PAGE
}];

for (let i = 0; i < app_routes.length; i++) {
    let layout = app_routes[i];
    let layout_component = layout.component;
    let layout_childs = layout.children;

    let router: any = {
        path: '',
        component: layout_component,
        children: []
    };

    for (let j = 0; j < layout_childs.length; j++) {
        let child = layout_childs[j];
        router.children.push({
            matcher: (url: any) => {
                let matcher = patternMatcher(child.path, url);
                if (matcher) return matcher;
                return null;
            },
            component: child.component
        });
    }
    routes.push(router);
}

@NgModule({ imports: [RouterModule.forRoot(routes)], exports: [RouterModule] })
export class AppRoutingModule { }